import { IValidationRule } from "@/types"

/**
 * Rules for the manually set depreciation period IFRS.
 *
 * Only the static rules live here. The upper and lower bounds come from the tenant settings and
 * are delivered per asset in the evaluation read model, so the edit modal checks them against the
 * current values instead. The service enforces all of them regardless.
 */
const depreciationPeriodIfrsValidationRules: { [s: string]: IValidationRule } = {
    period: {
        required: true,
        type: "integer",
        gt: 0,
    },
    comment: {
        required: false,
        max: 300,
    },
}

export default depreciationPeriodIfrsValidationRules
